import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

export function RoleGaurd({ children, module, permission, isRedirect = false, redirectUrl = "/" }) {
  const { isModuleLoading, slug } = useSelector((state) => state.permissions, shallowEqual);
  const { isPermissionAvailable } = useRoleGaurdHook();
  if (isModuleLoading) {
    return <></>;
  }
  if (slug === "super_admin") return children;
  // validate role and permissions
  if (!isPermissionAvailable({ module, permission })) {
    if (isRedirect) {
      return <Navigate to={redirectUrl} replace />;
    }
    return <></>;
  }

  return children;
}

RoleGaurd.propTypes = {
  children: PropTypes.node.isRequired,
  module: PropTypes.string.isRequired,
  permission: PropTypes.string.isRequired,
  isRedirect: PropTypes.bool,
  redirectUrl: PropTypes.string,
};

export const useRoleGaurdHook = () => {
  const { slug, formatedModulesData } = useSelector((state) => state.permissions, shallowEqual);
  const isPermissionAvailable = ({ module = "", permission = "" }) => {
    if (slug === "super_admin") return true;
    if (module === "default") return true;
    if (Array.isArray(module)) {
      return module.find((mod) => formatedModulesData?.[mod]?.permissions?.[permission]) || false;
    }
    return formatedModulesData?.[module]?.permissions?.[permission] || false;
  };
  return { isPermissionAvailable };
};
